import CurrencyLogo from 'components/CurrencyLogo'
import Tag from 'components/Tag'
import React, { useState } from 'react'

import { EntriesStyled, PoolCardStyled } from './styled'
import { SkeletonText } from 'components/Skeleton'
import { useToken } from 'hooks/Tokens'
import { HYPERBEAT_TOKEN_ADDRESS } from '@hyperswap/addresses'
import { Currency } from '@uniswap/sdk-core'
import HyperbeatLogo from '../../../assets/hyperbeat-logo.svg'
import { roundToDecimalPlace } from 'utils/data'
import { EARN_HBHYPE_IS_DISABLED } from 'constants/config'

import { useActiveWeb3React } from 'hooks'
import axios from 'axios'
import { API_POOL_BASE_URL } from 'constants/links'

const IS_DISABLED = EARN_HBHYPE_IS_DISABLED

const HBHYPEPoolCard: React.FC = () => {
  const { library, account } = useActiveWeb3React()
  const lHYPEToken = useToken(HYPERBEAT_TOKEN_ADDRESS)
  const [data, setData] = useState<any>({
    apr: null,
    tvl: null,
  })
  const [loading, setLoading] = useState<boolean>(true)

  React.useEffect(() => {
    async function fetchData() {
      if (library && account) {
        try {
          const dataAPI = await axios.get(`${API_POOL_BASE_URL}/api/hbHype/totalSupply`)
          const lastTVL = dataAPI.data?.data?.timeseriesCalls?.[0]?.data.sort(
            (a: any, b: any) => b.timestamp - a.timestamp
          )[0]?.value
          const totalSupply = lastTVL

          setData({
            apr: '6',
            tvl: totalSupply ? totalSupply : null,
          })

          setLoading(false)
        } catch (error) {
          console.error(error)
          setLoading(false)
        }
      }
    }

    if (loading) {
      fetchData()
    }
  }, [account, library, loading])

  return (
    <PoolCardStyled role="button" to={`/stake/hbHYPE`} disabled={IS_DISABLED}>
      <div className="poolCard__tag">
        {IS_DISABLED ? <Tag variant={1}>Inactive</Tag> : <Tag variant={2}>Active</Tag>}
      </div>

      <div className="poolCard__header">
        <CurrencyLogo currency={lHYPEToken as Currency} size={'42px'} />
        <h2>Earn hbHYPE</h2>
      </div>
      <div className="poolCard__subheader">
        <div style={{ display: 'flex', alignItems: 'center', gap: '2px' }}>
          <span>Powered by</span>{' '}
          <img
            src={HyperbeatLogo}
            alt="hyperbeat logo"
            style={{ width: '16px', borderRadius: '100px', margin: '0 2px' }}
          />
          <span>Hyperbeat</span>
        </div>
      </div>
      <EntriesStyled>
        <span style={{ fontWeight: 500, fontSize: '14px' }}>APY</span>
        <span style={{ fontWeight: 500, fontSize: '14px' }}>TVL</span>
        <span style={{ height: '16px', fontSize: '12px' }}>
          {loading || !data?.apr || IS_DISABLED ? (
            <SkeletonText width="50%" height="100%" />
          ) : (
            `${roundToDecimalPlace(data?.apr, '2')}%`
          )}
        </span>
        <span style={{ height: '16px', fontSize: '12px' }}>
          {loading || !data?.tvl || IS_DISABLED ? (
            <SkeletonText width="80%" height="100%" />
          ) : (
            `${roundToDecimalPlace(data?.tvl, '3')} hbHYPE`
          )}
        </span>
      </EntriesStyled>
    </PoolCardStyled>
  )
}
export default HBHYPEPoolCard
